var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('templates-combobox',_vm._b({attrs:{"items":_vm.items,"label":_vm.$t('Disabled Templates')},model:{value:(_vm.disabled),callback:function ($$v) {_vm.disabled=$$v},expression:"disabled"}},'templates-combobox',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }